import { render, staticRenderFns } from "./_orders.tab.vue?vue&type=template&id=b3f4e17a"
import script from "./_orders.tab.vue?vue&type=script&lang=js"
export * from "./_orders.tab.vue?vue&type=script&lang=js"
import style0 from "./_orders.tab.vue?vue&type=style&index=0&id=b3f4e17a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports